import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { TextLinkButton, styleVariables } from '@lib/common';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTruncatedText = styled.div.withConfig({
  displayName: "comment-previewcomponent__StyledTruncatedText",
  componentId: "sc-wib3vg-0"
})(["overflow:hidden;text-overflow:ellipsis;max-height:", ";"], function (props) {
  return props.isShortView ? "".concat(props.maxHeight, "px") : 'none';
});
var StyledCommentContent = styled.div.withConfig({
  displayName: "comment-previewcomponent__StyledCommentContent",
  componentId: "sc-wib3vg-1"
})(["padding:0px 8px 8px 8px;font-style:italic;font-size:14px;line-height:22px;color:", ";p{margin:0;}"], styleVariables.colors.gray12);
var StyledLabel = styled.label.withConfig({
  displayName: "comment-previewcomponent__StyledLabel",
  componentId: "sc-wib3vg-2"
})(["font-style:italic;color:", ";"], styleVariables.colors.grey70);
export var CommentPreview = function CommentPreview(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      label = _ref.label,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 180 : _ref$maxHeight;
  var divRef = useRef(null);
  var truncatedRef = useRef(null);

  var _useState = useState(true),
      isShortView = _useState[0],
      setIsShortView = _useState[1];

  var _useState2 = useState(0),
      height = _useState2[0],
      setHeight = _useState2[1];

  useEffect(function () {
    if (!divRef.current) return;
    var resizeObserver = new ResizeObserver(function () {
      var _divRef$current;

      setHeight((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.offsetHeight);
    });
    resizeObserver.observe(divRef.current);
    return function () {
      return resizeObserver.disconnect();
    }; // clean up
  }, [divRef.current, value]);

  var renderMoreButton = function renderMoreButton() {
    var contentHeight = height || 0;

    if (contentHeight <= maxHeight) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }

    if (isShortView) {
      return /*#__PURE__*/_jsxs(TextLinkButton, {
        onClick: function onClick() {
          return setIsShortView(false);
        },
        children: ["...", label.seeMore]
      });
    }

    return /*#__PURE__*/_jsx(TextLinkButton, {
      onClick: function onClick() {
        return setIsShortView(true);
      },
      children: label.seeLess
    });
  };

  var renderContent = function renderContent() {
    if (!value) {
      return /*#__PURE__*/_jsx(StyledLabel, {
        children: "[".concat(label.noContent, "]")
      });
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledTruncatedText, {
        ref: truncatedRef,
        isShortView: isShortView,
        maxHeight: maxHeight,
        children: /*#__PURE__*/_jsx(StyledCommentContent, {
          ref: divRef,
          dangerouslySetInnerHTML: {
            __html: value
          }
        })
      }), renderMoreButton()]
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderContent()
  });
};